import { FunctionalComponent } from 'preact';

import HabitatLink from '@/components/HabitatLink';
import { trackMP } from '@/shared/mp';

interface HabitatProfileImageLinkProps {
  habitatId: string;
  slug: string;
  zooSlug: string;
  profileImage: string;
  title: string;
  zooLogo: string;
  zooName: string;
  entryPoint: string;
}

const HabitatProfileImageLink: FunctionalComponent<HabitatProfileImageLinkProps> = ({
  habitatId,
  slug,
  zooSlug,
  profileImage,
  title,
  zooLogo,
  zooName,
  entryPoint,
}) => (
  <HabitatLink
    productsPromptModalState={{ entryPoint }}
    habitatId={habitatId}
    slug={slug}
    zooSlug={zooSlug}
    className="preflight preflight-a"
    onClick={() => {
      trackMP('visit-habitat-link-clicked', {
        habitatId,
        entryPoint,
      });
    }}
  >
    <div className="relative hover:opacity-75">
      <img
        className="preflight preflight-img size-20 overflow-hidden rounded-2xl object-contain"
        src={profileImage}
        alt={`${title} habitat profile`}
      />
      <div className="absolute -bottom-1/4 -right-1/4 z-10 flex size-12 items-center justify-center overflow-hidden rounded-full bg-white shadow-[0_4px_4px_rgba(0,0,0,0.15)]">
        <img className="preflight preflight-img" src={zooLogo} alt={zooName} />
      </div>
    </div>
  </HabitatLink>
);

export default HabitatProfileImageLink;
